import { t } from '@lingui/core/macro';

export const getRequiredFieldErrorString = (): string => t`Required`;
